$(document).ready(function($) {
  console.log("heellllloooo");
// Get the modal
$(".myBtn").click(function(evt) {
console.log("FFF");
evt.preventDefault();
$("#myModal").show();
});
// When the user clicks on <span> (x), close the modal
$(".close").click(function() {
$("#myModal").hide();
});
$(window).click(function(event) {
console.log(event.target);
if (event.target == $("#myModal").get(0)) {
$("#myModal").hide();
}
});
});
